<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div  class='h100vh-100'>
          <div class="h-toolbarBg">
            <ejs-toolbar>
              <e-items>
                <e-item prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("Alarm.refresh")' :click="refreshMail"></e-item>
                <e-item prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("System.delete")' :click="deleteMail"></e-item>
              </e-items>
            </ejs-toolbar>
            <div class="h-inputBox">
              <input class="e-input" :placeholder='$t("System.inputMailTip")' @keyup.enter="getHistoryMail" v-model="keyString" />
            </div>
          </div>
          <div class="h100-40 ">
            <ejs-grid ref="grid" height='calc(100vh - 280px)' :allowSelection="true" :pageSettings="pageSettings">
              <e-columns>
                <e-column type="checkbox" width="50" textAlign="center"></e-column>
                <!--<e-column field="id" :visible="false"></e-column>-->
                <e-column
                  field="startTimeString"
                  isPrimaryKey="true"
                  :headerText='$t("System.sendEmailTime")'
                  format="yMd"
                  width="120"
                  textAlign="center"
                ></e-column>
                <e-column field="result" :headerText='$t("System.sendResult")'  width="80" textAlign="center"></e-column>
                <e-column field="mailTitle" :headerText='$t("System.emailTitle")'  width="120" textAlign="center"></e-column>
                <!--<e-column field="sysTaskId" :headerText='$t("System.timeTaskId")' width="120" textAlign="center" :visible="false"></e-column>-->
                <e-column field="description" :headerText='$t("System.description")'  width="120" textAlign="center" clipMode='EllipsisWithTooltip'></e-column>
              </e-columns>
            </ejs-grid>
            <ejs-pager
              ref="pager"
              :pageSize="pageSettings.pageSize"
              :pageCount="pageCount"
              @click="getHistoryMail"
            ></ejs-pager>
          </div>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from "../../layouts/BasicLayout";
import CustomDialog from "../../components/common/CustomDialog";
import {EventBus} from "../../plugins/eventBus";

export default {
  name: "Historymail",
  data() {
    return {
      left: { show: false, name: "" },
      middle: { show: false, name: "" },
      right: { show: true, crumb: `${this.$t('System.systemManager')}/${this.$t('System.systemNotice')}/${this.$t('System.emailQuery')}` },
      keyString: "",
      pageNo: "1",
      pageSettings: { pageSize: 25 },
      pageCount: "4"
    };
  },
  components: {
    BasicLayout,
    CustomDialog
  },
  methods: {
    refreshMail(){
      this.$loading.showLoadding(`${this.$t('System.loading')}`);
      this.getHistoryMail();
    },
    getHistoryMail() {
      const url = "/lte/ems/sysmanager/mail/getmaillog";
      this.pageNo = this.$refs.pager.ej2Instances.currentPage;
      let params = {
        keyword: this.keyString,
        pageNo: this.pageNo,
        pageSize: this.pageSettings.pageSize
      };
      this.axios.get(url, { params }).then(response => {
        this.$loading.hideLoadding();
        let result = response.data.result;
        let showRe = [];
        result.forEach((item, index) => {
          let re = {};
          re.id = item.id;
          re.sysTaskId = item.sysTaskId;
          re.description = item.mailLog;
          re.mailTitle = item.mailTitle;
          if (item.mailResult === 1) {
            re.result = `${this.$t('System.reFault')}`;
          } else {
            re.result = `${this.$t('System.reSuccess')}`;
          }
          re.startTimeString = item.startTimeString;
          showRe.push(re);
        });
        this.$refs.grid.ej2Instances.dataSource = showRe;
        this.$refs.pager.ej2Instances.totalRecordsCount =
          response.data.totalCount;
      });
    },
    deleteMail() {
      let selectedData = this.$refs.grid.getSelectedRecords();
      if (selectedData == null || selectedData == "") {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('System.selectOneMessage')});
        return null;
      }
      let params = [];
      selectedData.forEach((item, index) => {
        params.push(item.id);
      });
      const url = "/lte/ems/sysmanager/mail/deleteMaiData";
      this.axios.post(url, params).then(response => {
        if (response.data) {
          EventBus.$emit('toast', {type: 'success', content: this.$t('Common.tips.success')});
        } else {
          EventBus.$emit('toast', {type: 'error', content: this.$t('Common.tips.failure')});
        }
        this.getHistoryMail();
      });
    },
  },
  mounted() {
    this.getHistoryMail();
  }
};
</script>

<style>
</style>
